import { render, staticRenderFns } from "./MeetingsIndex.vue?vue&type=template&id=28394ca6"
import script from "./MeetingsIndex.vue?vue&type=script&lang=js"
export * from "./MeetingsIndex.vue?vue&type=script&lang=js"
import style0 from "./MeetingsIndex.vue?vue&type=style&index=0&id=28394ca6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports